import { themeVars } from '@coverflex-tech/hypernova';
import { globalStyle, style } from '@vanilla-extract/css';

const host = style({
  display: 'flex',
  flexDirection: 'column',
  gap: themeVars.spacing.lg,
  width: '100%',
});

const feedback = style({});

globalStyle(`${feedback} strong`, {
  wordBreak: 'break-all',
});

const button = style({
  alignSelf: 'flex-start',
});

export const css = { host, feedback, button };
